import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import { useStepperConfig } from '../stepper/stepper-config.context';

import * as styles from './step-headline.styles';

type Props = {
  children: ReactNode;
  className?: string;
};

export const StepHeadline = ({ children, className }: Props) => {
  const theme = useTheme();
  const { variant } = useStepperConfig();

  return (
    <div className={className} css={[styles.container(theme), styles.alignment[variant]]}>
      {children}
    </div>
  );
};
